var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-5"},[_c('b-col',[_c('router-view',{on:{"roles-changed":_vm.reloadOrganizationsPanel}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }